import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ISubmissionEvaluation } from 'types/submissions/submissions-evaluation'

type Props = {
  data: ISubmissionEvaluation[]
}

export const TenderContestResultTable = ({ data }: Props) => {
  const { t } = useTranslation()

  return (
    <TableContainer>
      <Table
        sx={{
          tableLayout: 'fixed',
          background: '#FFF',
          '& td, th': {
            border: '1px solid #ccc',
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>{t('supplier-name')}</TableCell>
            <TableCell>{t('technical-proposal')}</TableCell>
            <TableCell>{t('commercial-proposal')}</TableCell>
            <TableCell>{t('total-point')}</TableCell>
            <TableCell>{t('required-docs')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => {
            return (
              <TableRow key={index}>
                <TableCell>{item.submitterOrganizationName || '-'}</TableCell>
                <TableCell>{item.technicalEvaluationScore || '-'}</TableCell>
                <TableCell>{item.procurementEvaluationScore || '-'}</TableCell>
                <TableCell>{item.totalScore || '-'}</TableCell>
                <TableCell>
                  {item.status ? t(`tender-contest-table-${item.status}`) : '-'}
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
